<template>
  <div
    for="filter"
    class="plans-switch size-lg"
    aria-label="Toggle Standard and Plus Plans"
  >
    <label class="margin-0">
      <input
        id="plus"
        :checked="value === 'plus'"
        type="radio"
        name="plans"
        class="plus sr-only"
        value="plus"
        @change="togglePlans"
      />
      <span><i class="slider-icon fa-solid fa-sparkles margin-right-2xs"></i> Pro+ Plans</span>
    </label>
    <label class="margin-0">
      <input
        id="standard"
        :checked="value === 'pro'"
        type="radio"
        name="plans"
        class="standard sr-only"
        value="pro"
        @change="togglePlans"
      />
      <span><i class="slider-icon fa-solid fa-globe margin-right-2xs"></i> Pro Plans</span>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'SlideToggle',

    props: {
      value: {
        type: String
      }
    },

    methods: {
      togglePlans(event) {
        this.$emit('input', event.target.value)
      }
    }
  }
</script>
